"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2977],{

/***/ 35888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ PlanComparison; }
});

// UNUSED EXPORTS: planComparisionFields

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/pricing/BillingIntervalToggle/useBillingIntervalToggle.ts
var useBillingIntervalToggle = __webpack_require__(9672);
// EXTERNAL MODULE: ./src/config/index.ts + 4 modules
var config = __webpack_require__(26499);
// EXTERNAL MODULE: ./src/modules/select-plan-comparison/SelectPlanComparisonLayout.tsx
var SelectPlanComparisonLayout = __webpack_require__(37822);
// EXTERNAL MODULE: ./src/modules/select-plan-comparison/SelectPlanComparisonMobileNav.tsx
var SelectPlanComparisonMobileNav = __webpack_require__(47177);
// EXTERNAL MODULE: ./src/modules/select-plan-comparison/utils.ts
var utils = __webpack_require__(13772);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/StructuredText/index.js + 3 modules
var StructuredText = __webpack_require__(86542);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/datocms-structured-text-utils/dist/esm/guards.js
var guards = __webpack_require__(62338);
// EXTERNAL MODULE: ./src/api/index.ts + 5 modules
var api = __webpack_require__(8814);
// EXTERNAL MODULE: ./src/components/index.ts + 103 modules
var components = __webpack_require__(80338);
// EXTERNAL MODULE: ./src/modules/select-plan-comparison/hooks.tsx
var hooks = __webpack_require__(976);
// EXTERNAL MODULE: ./src/styles/custom.module.css
var custom_module = __webpack_require__(95032);
var custom_module_default = /*#__PURE__*/__webpack_require__.n(custom_module);
// EXTERNAL MODULE: ./src/utils/index.ts + 7 modules
var src_utils = __webpack_require__(20978);
// EXTERNAL MODULE: ./node_modules/@narrative-software/narrative-web-ui/dist/index.js
var dist = __webpack_require__(67199);
// EXTERNAL MODULE: ./src/components/BlackFriday/BlackFridayPlanComparison.tsx + 5 modules
var BlackFridayPlanComparison = __webpack_require__(72700);
;// CONCATENATED MODULE: ./src/components/PlanComparison/ComparisonPlan.tsx
















var ComparisonPlan = function(param) {
    var position = param.position, billingInterval = param.billingInterval, plan = param.plan;
    var // presentational data (for this page/instance only)
    showRainbowBar = plan.showRainbowBar, ctaDisabled = plan.ctaDisabled, showCouponSavings = plan.showCouponSavings, ctaLabel = plan.ctaLabel, ctaAppearance = plan.ctaAppearance, _planData = plan.// plan data (all pages)
    planData, planName = _planData.planName, description = _planData.description, features = _planData.features, stripePlanSlug = _planData.stripePlanSlug, yearlyPrice = _planData.yearlyPrice, monthlyPrice = _planData.monthlyPrice, stripeCoupon = plan.stripeCoupon;
    var ref = getCalculatedDiscount(billingInterval, plan), hasDiscount = ref.hasDiscount, discountedPrice = ref.discountedPrice, discountedPriceDollars = ref.discountedPriceDollars, discountedPriceCents = ref.discountedPriceCents, customDiscountBanner = ref.customDiscountBanner, yearlySavings = ref.yearlySavings;
    var special = (0,BlackFridayPlanComparison/* getPlanSpecialType */.u)(plan.planData);
    var _ref = (0,hooks/* useToggleOverflow */.V)(), overflowRef = _ref.ref, featureOverflow = (0,_object_without_properties/* default */.Z)(_ref, [
        "ref"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            width: "100%"
        },
        id: "".concat(stripePlanSlug),
        className: classnames_default()("md:col-span-5 w-full flex flex-col lg:flex-1 relative", (custom_module_default())["scroll-snap-child"], {
            "bg-stealth-bomber text-white": !!special,
            "bg-white": !special,
            "md:col-start-2": position === 0,
            "bg-gradient-to-r from-[#31256F] to-[#FCB76F] via-[#B44893]": !special,
            "lifetime-box-gradient-select": special === "bf-select",
            "bg-slowpoke": special === "bf-publish",
            // Reveal the gradient background
            "px-[1px] pb-[1px] pt-2": showRainbowBar && !special,
            "p-[2px]": showRainbowBar || special,
            "border-1": !showRainbowBar && !special
        }),
        children: [
            hasDiscount && !customDiscountBanner && showCouponSavings && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute right-0 top-0 bg-[#FFDA18] text-stealth-bomber py-2 px-4 rounded-bl-lg font-semibold font-18",
                children: [
                    "Save ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-light",
                        children: "$"
                    }),
                    yearlySavings
                ]
            }),
            customDiscountBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute right-0 top-0 bg-[#FFDA18] text-stealth-bomber py-2 px-4 rounded-bl-lg font-semibold font-18",
                children: customDiscountBanner
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("bg-white pb-10 md:pb-13 flex flex-col h-full", {
                    "pt-[29px]": showRainbowBar,
                    "pt-9": !showRainbowBar,
                    "select-plan-background-gradient": !!special,
                    "bg-white": !special
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("flex flex-col items-center px-10 pt-6 pb-6 border-b-1 text-center min-h-[210px]", {
                            "border-gumboot": !!special
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: classnames_default()("relative mb-2.5 text-h3 leading-none md:text-34 font-semibold"),
                                children: planName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative text-6xl font-semibold leading-none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                        className: "absolute mt-7 -ml-4 text-2xl font-light",
                                        children: "$"
                                    }),
                                    hasDiscount ? discountedPriceCents === "00" ? discountedPrice : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tracking-[-5px]",
                                                children: discountedPriceDollars
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-34",
                                                children: [
                                                    ".",
                                                    discountedPriceCents
                                                ]
                                            })
                                        ]
                                    }) : (0,src_utils/* numberToCurrency */.fe)(billingInterval === api/* ProductInterval.Month */.g7.Month ? monthlyPrice : yearlyPrice, true),
                                    hasDiscount && showCouponSavings && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute bottom-[15%] w-[100px] left-[95%]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-shadyLady text-[15px]",
                                            children: [
                                                "usually",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "strikethrough",
                                                    children: (0,src_utils/* numberToCurrency */.fe)(billingInterval === api/* ProductInterval.Month */.g7.Month ? monthlyPrice : yearlyPrice)
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-1 leading-relaxed",
                                children: (0,guards/* isEmptyDocument */.RL)(description) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "USD per month, billed\xa0",
                                        billingInterval === api/* ProductInterval.Month */.g7.Month ? "monthly" : "yearly"
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredText/* StructuredText */.rZ, {
                                    data: description
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 md:px-8 pt-8 relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: overflowRef,
                                className: classnames_default()("transition-[max-height] overflow-hidden", {
                                    "max-h-[440px] md:max-h-[310px]": !featureOverflow.isOpen,
                                    "max-h-[600px]": featureOverflow.isOpen
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: features.map(function(feature) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "text-sm flex items-center justify-between mb-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center md:mr-5",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: classnames_default()("mr-5", {
                                                                "text-slowpoke": special === "bf-publish",
                                                                "text-gengar": special !== "bf-publish"
                                                            }),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CheckIcon */.nQ, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredText/* StructuredText */.rZ, {
                                                            data: feature.name
                                                        })
                                                    ]
                                                }),
                                                feature.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* InfoTooltip */.bE, {
                                                    description: feature.description,
                                                    special: special
                                                })
                                            ]
                                        }, feature.id);
                                    })
                                })
                            }),
                            featureOverflow.hasOverflow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    !featureOverflow.isOpen && !special && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-[66px] w-full left-0 bottom-[30px] bg-gradient-to-t from-white to-transparent absolute"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "text-sm py-2 flex items-center w-[60px] justify-between",
                                        onClick: function() {
                                            return featureOverflow.toggle();
                                        },
                                        children: [
                                            featureOverflow.isOpen ? "Less" : "More",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DownChevronIcon */.ab, {
                                                className: classnames_default()("origin-center", {
                                                    "rotate-180": featureOverflow.isOpen
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-4 md:px-8 mt-auto",
                        children: ctaDisabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                            appearance: "primary",
                            colour: "gray-600",
                            disabled: true,
                            className: "text-sm normal-case",
                            children: ctaLabel
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.AnchorButton, {
                            href: getCtaButtonHref((stripeCoupon === null || stripeCoupon === void 0 ? void 0 : stripeCoupon.code) || "", plan.planData, billingInterval),
                            appearance: ctaAppearance,
                            colour: "gray-600",
                            className: classnames_default()("text-sm normal-case", {
                                "lifetime-background-gradient-publish border-none !text-white": special === "bf-publish",
                                "lifetime-background-gradient-select border-none !text-white": special === "bf-select"
                            }),
                            children: ctaLabel
                        })
                    })
                ]
            })
        ]
    });
};
/**
 * Coupon Discounts can be displayed individually at the page level or universally at the plan level. If both are
 * applied, currently we prefer the page level coupon.
 */ function getCalculatedDiscount(billingInterval, param) {
    var customCouponBanner = param.customCouponBanner, stripeCoupon = param.stripeCoupon, _planData = param.planData, stripeCouponDiscount = _planData.stripeCouponDiscount, stripeCouponCode = _planData.stripeCouponCode, stripeCouponAppliesMonthly = _planData.stripeCouponAppliesMonthly, stripeCouponAppliesYearly = _planData.stripeCouponAppliesYearly, monthlyPrice = _planData.monthlyPrice, yearlyPrice = _planData.yearlyPrice;
    var ref;
    var hasPageLevelCoupon = stripeCoupon && stripeCoupon.discount;
    var ref1 = hasPageLevelCoupon && stripeCoupon || {
        discount: stripeCouponDiscount,
        appliesMonthly: stripeCouponAppliesMonthly,
        appliesYearly: stripeCouponAppliesYearly
    }, discount = ref1.discount, appliesMonthly = ref1.appliesMonthly, appliesYearly = ref1.appliesYearly;
    if (!discount) {
        return {
            hasDiscount: false
        };
    }
    if (billingInterval === api/* ProductInterval.Month */.g7.Month && !appliesMonthly) {
        return {
            hasDiscount: false
        };
    }
    if (billingInterval === api/* ProductInterval.Year */.g7.Year && !appliesYearly) {
        return {
            hasDiscount: false
        };
    }
    var priceWithDiscountDollars = (billingInterval === api/* ProductInterval.Month */.g7.Month ? monthlyPrice : yearlyPrice) * (1 - discount);
    var ref2 = (0,_sliced_to_array/* default */.Z)((priceWithDiscountDollars / 100).toFixed(2).split("."), 2), dollars = ref2[0], cents = ref2[1];
    var yearlySavings = Intl.NumberFormat("en").format(yearlyPrice * discount * 12 / 100);
    return {
        hasDiscount: true,
        discountedPrice: (0,src_utils/* numberToCurrency */.fe)(priceWithDiscountDollars, true),
        discountedPriceDollars: dollars,
        discountedPriceCents: cents,
        yearlySavings: yearlySavings,
        customDiscountBanner: (ref = hasPageLevelCoupon ? customCouponBanner : undefined) === null || ref === void 0 ? void 0 : ref.replace("{yearlySavings}", String(yearlySavings))
    };
}
/**
 * Send the user to sign up with specific plan details.
 */ function getCtaButtonHref(couponCode, planData, interval) {
    if (config/* SELECT_PLAN_SLUGS.defaultPro */.Rv.defaultPro === planData.stripePlanSlug) {
        return (0,src_utils/* createUrl */.uJ)(config/* EXTERNAL.SIGN_UP.HREF */.IK.SIGN_UP.HREF, {
            interval: interval,
            product: "select",
            backPath: "/checkout",
            planID: planData.stripePlanId,
            fp_ref: couponCode
        });
    }
    return (0,src_utils/* createUrl */.uJ)(config/* EXTERNAL.SELECT.GET_STARTED.HREF */.IK.SELECT.GET_STARTED.HREF, {
        fp_ref: couponCode
    });
}


// EXTERNAL MODULE: ./src/components/PlanComparison/PlanComparisonSection.tsx + 2 modules
var PlanComparisonSection = __webpack_require__(13154);
;// CONCATENATED MODULE: ./src/components/PlanComparison/PlanComparison.tsx









var planComparisionFields = "\n  title\n  description {\n    value\n  }\n  darkMode\n  showBillingIntervalControl\n  showSectionIntroDivider\n  backgroundImage {\n    responsiveImage {\n      src\n    }\n  }\n  plans {\n    ctaLabel\n    ctaDisabled\n    ctaAppearance\n    showRainbowBar\n    customCouponBanner\n    showCouponSavings\n    stripeCoupon {\n      code\n      discount\n      appliesYearly\n      appliesMonthly\n    }\n    planData {\n      id\n      planName\n      stripePlanSlug\n      description {\n        value\n      }\n      features {\n        id\n        name {\n          value\n        }\n        description\n      }\n    }\n  }\n";
/**
 * Partially reimplemented version of SelectPlanComparison that adds a new data layer to separate plan display params
 * from plan data, and to make it easier to create/configure new pages.
 */ var PlanComparison = function(param) {
    var title = param.title, description = param.description, showBillingIntervalControl = param.showBillingIntervalControl, showSectionIntroDivider = param.showSectionIntroDivider, darkMode = param.darkMode, backgroundImage = param.backgroundImage, _plans = param.plans, plans = _plans === void 0 ? [] : _plans, _stripePlans = param.stripePlans, stripePlans = _stripePlans === void 0 ? [] : _stripePlans;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useBillingIntervalToggle/* useBillingIntervalToggle */.N)(), 2), billingInterval = ref[0], setBillingInterval = ref[1];
    var plansWithPriceData = (0,utils/* mergeCMSPlanWithStripePlan */.T)(plans, stripePlans);
    var isBlackFridayPlanPresent = plansWithPriceData.some(function(plan) {
        return plan.planData.blackFridayPlan;
    });
    // Switch stand pro plan for Black Friday plan if present and on yearly view
    var plansToDisplay = isBlackFridayPlanPresent ? plansWithPriceData.filter(function(param) {
        var plan = param.planData;
        return config/* SELECT_PLAN_SLUGS.allFree.includes */.Rv.allFree.includes(plan.stripePlanSlug) || (billingInterval === "month" ? !plan.blackFridayPlan : plan.blackFridayPlan);
    }) : plansWithPriceData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanComparisonSection/* PlanComparisonSection */.K, {
        title: title,
        description: description,
        showBillingIntervalControl: showBillingIntervalControl,
        showSectionIntroDivider: showSectionIntroDivider,
        darkMode: darkMode,
        backgroundImage: backgroundImage,
        billingInterval: billingInterval,
        setBillingInterval: setBillingInterval,
        planComparison: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPlanComparisonLayout/* SelectPlanComparisonLayout */.U, {
            children: plansToDisplay.map(function(plan, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonPlan, {
                    position: i,
                    plan: plan,
                    billingInterval: billingInterval
                }, plan.planData.stripePlanId);
            })
        }),
        planComparisonMobileNav: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPlanComparisonMobileNav/* SelectPlanComparisonMobileNav */.h, {
            plans: plansToDisplay.map(function(param) {
                var _planData = param.planData, name = _planData.planName, slug = _planData.stripePlanSlug;
                return {
                    name: name,
                    slug: slug
                };
            })
        })
    });
};



/***/ }),

/***/ 6985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SiteBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86542);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76195);
/* harmony import */ var datocms_structured_text_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62338);



function SiteBanner(param) {
    var content = param.content, enabled = param.enabled;
    return enabled && !(0,datocms_structured_text_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEmptyDocument */ .RL)(content) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-stealth-bomber text-white px-7 py-4 flex justify-center text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_2__/* .StructuredText */ .rZ, {
            data: content,
            customMarkRules: [
                (0,react_datocms__WEBPACK_IMPORTED_MODULE_3__/* .renderMarkRule */ .zf)("strong", function(param) {
                    var children = param.children, key = param.key;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        className: "font-medium",
                        children: children
                    }, key);
                }), 
            ]
        })
    }) : null;
}



/***/ }),

/***/ 62977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "COMPANY_LOGOS": function() { return /* binding */ COMPANY_LOGOS; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages_select; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/useQuerySubscription/index.js + 2 modules
var useQuerySubscription = __webpack_require__(63430);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/Seo/renderMetaTags.js
var renderMetaTags = __webpack_require__(12569);
// EXTERNAL MODULE: ./src/components/index.ts + 103 modules
var components = __webpack_require__(80338);
// EXTERNAL MODULE: ./src/components/PlanComparison/PlanComparison.tsx + 1 modules
var PlanComparison = __webpack_require__(35888);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/Image/index.js + 3 modules
var Image = __webpack_require__(44087);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/config/index.ts + 4 modules
var config = __webpack_require__(26499);
// EXTERNAL MODULE: ./node_modules/@narrative-software/narrative-web-ui/dist/index.js
var dist = __webpack_require__(67199);
;// CONCATENATED MODULE: ./src/components/edit-intro-section/EditIntroSection.tsx






// Fragment
var editIntroSectionFragment = "\n  fragment editIntroSectionFragment on EditIntroSectionRecord {\n    title\n    description\n    image {\n      responsiveImage(imgixParams: { auto: format, fit: crop, w: 687, h: 458 }) {\n        ...responsiveImageFragment\n      }\n    }\n    ctaText\n  }\n";
function EditIntroSection(param) {
    var title = param.title, description = param.description, ctaText = param.ctaText, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "py-20 md:py-30 bg-ekans relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/images/textures/ekans-bg@2x.png",
                alt: "",
                draggable: false,
                layout: "fill",
                quality: 100,
                sizes: "100vw",
                objectFit: "cover",
                objectPosition: "center"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 flex flex-col-reverse lg:flex-row gap-10 md:gap-6 lg:gap-10 text-white relative text-center items-center md:text-left md:max-w-[1232px] justify-center w-full mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full max-w-[687px] lg:w-[460px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-h2 font-semibold mb-2 leading-tight",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pr-0 lg:pr-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: description
                                        },
                                        className: "[&_strong]:font-semibold mb-12"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.AnchorButton, {
                                        colour: "white",
                                        href: "/".concat(config/* ROUTES.EDIT.BASE.SLUG */.Z6.EDIT.BASE.SLUG),
                                        children: ctaText
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full md:w-[687px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            data: (0,_object_spread/* default */.Z)({}, image.responsiveImage)
                        })
                    })
                ]
            })
        ]
    });
}


// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/edit-launch-promo-section/EditLaunchPromoSection.tsx





// Fragment
var editLaunchPromoSectionFragment = "\n  fragment editLaunchPromoSectionFragment on EditLaunchPromoSectionRecord {\n    title\n    subtitle\n    description\n    ctaText\n    compact\n  }\n";
function EditLaunchPromoSection(param) {
    var title = param.title, subtitle = param.subtitle, description = param.description, ctaText = param.ctaText, compact = param.compact;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()("relative text-white", {
            "py-40 md:py-56": !compact,
            "py-28": compact
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/images/edit/launch-sale-bg-".concat(compact ? "sm" : "lg", ".webp"),
                alt: "",
                className: "absolute top-0 right-0 bottom-0 left-0",
                layout: "fill",
                objectFit: "cover",
                objectPosition: "center",
                sizes: "100vw",
                draggable: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 right-0 bottom-0 left-0",
                style: {
                    background: "radial-gradient(circle, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 100%)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center relative text-center px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: classnames_default()("font-semibold leading-tight", {
                            "text-4xl md:text-5xl": !compact,
                            "text-3xl md:text-4xl": compact
                        }),
                        children: [
                            title,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-jolteon",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-5 mb-7",
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.AnchorButton, {
                        colour: "ekans",
                        className: "max-w-90",
                        href: "/".concat(config/* ROUTES.EDIT.PRICING.SLUG */.Z6.EDIT.PRICING.SLUG),
                        children: ctaText
                    })
                ]
            })
        ]
    });
}


// EXTERNAL MODULE: ./src/components/lifetime-deal/DealOfLifeTimeBanner.tsx + 1 modules
var DealOfLifeTimeBanner = __webpack_require__(80411);
// EXTERNAL MODULE: ./public/images/fstoppers.png
var fstoppers = __webpack_require__(91025);
;// CONCATENATED MODULE: ./public/images/photo-bug.png
/* harmony default export */ var photo_bug = ({"src":"/_next/static/media/photo-bug.a503d6f9.png","height":98,"width":445,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAADFBMVEXu7u7p6env7+/29vYw7A56AAAAAnRSTlPd/hgAqXEAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAYSURBVHicBcEBAQAAAAEg8v+zCrRLsFoOAREAHboiPVQAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./public/images/shotkit.png
var shotkit = __webpack_require__(81545);
// EXTERNAL MODULE: ./public/images/slr-lounge.png
var slr_lounge = __webpack_require__(57279);
// EXTERNAL MODULE: ./src/modules/index.ts + 42 modules
var modules = __webpack_require__(88038);
// EXTERNAL MODULE: ./src/modules/site-banner.tsx
var site_banner = __webpack_require__(6985);
;// CONCATENATED MODULE: ./src/pages/select/index.tsx
















var __N_SSG = true;
var COMPANY_LOGOS = [
    {
        src: fstoppers/* default */.Z,
        width: 155,
        height: 42,
        companyName: "Fstoppers"
    },
    {
        src: shotkit/* default */.Z,
        width: 143,
        height: 41,
        companyName: "ShotKit"
    },
    {
        src: slr_lounge/* default */.Z,
        width: 177,
        height: 69,
        companyName: "SLR Lounge"
    },
    {
        src: photo_bug,
        width: 222,
        height: 49,
        companyName: "Photo Bug"
    }, 
];
var SelectPage = function(param) {
    var preview = param.preview, subscription = param.subscription, plans = param.plans;
    var ref = (0,useQuerySubscription/* useQuerySubscription */.L)(subscription), tmp = ref.data, ref1 = tmp === void 0 ? {} : tmp, data = ref1.page, banner = ref1.banner;
    if (!data) return null;
    var stats = data.stats, faqs = data.faqs, testimonials = data.testimonials, planComparison = data.planComparison, seo = data.seo, dealBanner = data.dealBanner, editIntroSection = data.editIntroSection, editLaunchPromoSection = data.editLaunchPromoSection;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Layout */.Ar, {
        product: "select",
        preview: preview,
        siteBanner: banner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(site_banner/* SiteBanner */.b, (0,_object_spread/* default */.Z)({}, banner)) : null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SEO */.HJ, {
                title: "Narrative Select | Fast image selection | Photographers",
                children: (0,renderMetaTags/* renderMetaTags */.y)(seo)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* HeroSection */.DH, {
                product: "select",
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Cull your photoshoot ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                            children: "twice"
                        }),
                        " as fast"
                    ]
                }),
                videoSrc: "/videos/select-video.webm",
                videoPoster: "/images/select-video-placeholder@2x.jpg",
                videoAspectRatio: 1980 / 1208,
                videoLoop: true,
                children: "Narrative is our game-changing image culling software, powered by smart tech & designed from the ground up for the professional photographer."
            }),
            stats ? /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Stat */.kN, (0,_object_spread/* default */.Z)({}, stats)) : null,
            dealBanner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DealOfLifeTimeBanner/* default */.Z, (0,_object_spread/* default */.Z)({}, dealBanner)) : null,
            testimonials && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Carousel */.lr, (0,_object_spread/* default */.Z)({}, testimonials)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanComparison/* PlanComparison */.m, (0,_object_spread/* default */.Z)({
                stripePlans: plans
            }, planComparison)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-col items-center py-12 px-12 bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CredibilityBar */.KW, {
                        logos: COMPANY_LOGOS,
                        label: "Featured in:"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SelectKeyFeaturesSection */.wh, {
                title: "Make quick decisions on the quality of your images"
            }),
            editIntroSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditIntroSection, (0,_object_spread/* default */.Z)({}, editIntroSection)),
            editLaunchPromoSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditLaunchPromoSection, (0,_object_spread/* default */.Z)({}, editLaunchPromoSection)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* NarrativeWorkflowSection */.Tq, {
                title: "How Narrative fits into your image selection workflow",
                steps: [
                    {
                        title: "Import",
                        description: "Import thousands of RAWs in 3 seconds"
                    },
                    {
                        title: "Cull",
                        description: "Cull your photoshoot in half the time with Narrative"
                    },
                    {
                        title: "Edit",
                        description: "One click import to Lightroom CC or Classic"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PromoBanner, {
                title: "Try our game changing software today",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "block",
                            children: "Get started with Narrative for free on macOS and Windows."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "block mt-4",
                            children: "Unlimited projects | Unlimited images | Integrates with Lightroom."
                        })
                    ]
                }),
                form: config/* IS_GOOGLE_AUTH_ENABLED */.Hw ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* StartFreeButtons */.zH, {
                    product: "select",
                    className: "max-w-130"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SignUpForm */.WS, {
                    product: "select",
                    className: "max-w-160",
                    textClassName: "text-white"
                }),
                backgroundColour: "gengar",
                backgroundImagePath: "/images/textures/purple-bg@2x.png",
                large: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CustomerCareSection */.CF, {
                product: "select"
            }),
            faqs && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Accordion */.UQ, (0,_object_spread/* default */.Z)({}, faqs))
        ]
    });
};
/* harmony default export */ var pages_select = (SelectPage);


/***/ })

}]);